/* Pine Park Space Run v2: the on-page loader (docs/game-v2/contracts.md section 2).
   The only game file that loads with the page. It binds PLAY; on the first PLAY
   it loads game.css, the seven game scripts and Tone.js, unlocks audio inside
   the gesture, then hands over to PPG.core.launch(). Each file is requested
   once per page (a failed one is retried on the next click). Vanilla ES5. */
(function () {
  'use strict';

  var W = window;
  var D = document;
  var TAG = '\uD83D\uDD79\uFE0F';
  var NAMES = ['init', 'launch', 'returnToSite', 'start', 'pause', 'resume', 'destroy'];
  var ORDER = ['core', 'render', 'render2d', 'play', 'boss', 'ui', 'audio'];
  var api = {};
  var i;

  function noop() {}

  /* Rule 23: off in the theme editor; and nothing to do without the overlay. */
  if (!D.getElementById('game-overlay') || (W.Shopify && W.Shopify.designMode)) {
    for (i = 0; i < NAMES.length; i++) { api[NAMES[i]] = noop; }
    W.PineParkGame = api;
    return;
  }

  var PPG = W.PPG = W.PPG || {};
  var L = PPG.loader = PPG.loader || { state: 'idle', tone: 'idle' };
  var cfg = W.PineParkGameConfig || {};
  var urls = cfg.assets || {};
  var files = {};          /* css and ORDER keys: 'loading', 'loaded' or 'failed' */
  var cssLink = null;
  var gameTimer = 0;
  var btn = null;
  var warned = {};
  var primer = null;
  var primerTimer = 0;
  var audioReady = false;  /* PPG.audio.init() returned true */
  var audioDead = false;   /* init ran and failed: the game stays silent */
  var gesture = [];        /* the PLAY gesture's timers, 100 ms apart up to 900 ms */
  var hooked = false;

  function warn(key, msg) {
    if (warned[key]) { return; }
    warned[key] = true;
    try { W.console.warn(TAG + ' ' + msg); } catch (e) { /* no console */ }
  }

  function settle(p) {
    if (p && typeof p.then === 'function') { p.then(noop, noop); }
  }

  function head() {
    return D.head || D.documentElement;
  }

  function setBusy(on) {
    if (!btn) { return; }
    btn.disabled = on;
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      btn.style.opacity = '0.6';
    } else {
      btn.removeAttribute('aria-busy');
      btn.style.opacity = '';
    }
  }

  /* ---------- audio: primer, init, start inside a gesture ---------- */

  /* iOS unlock: one silent sample on a primer context, inside the click.
     It is suspended again a second later so it costs nothing while idle. */
  function prime() {
    var AC = W.AudioContext || W.webkitAudioContext;
    var src;
    if (!AC) { return; }
    try {
      if (!primer) { primer = new AC(); }
      if (primer.state !== 'running' && primer.resume) { settle(primer.resume()); }
      src = primer.createBufferSource();
      src.buffer = primer.createBuffer(1, 1, 22050);
      src.connect(primer.destination);
      if (src.start) { src.start(0); } else { src.noteOn(0); }
      clearTimeout(primerTimer);
      primerTimer = setTimeout(function () {
        primerTimer = 0;
        try { if (primer.suspend) { settle(primer.suspend()); } } catch (e) { /* ignore */ }
      }, 1000);
    } catch (e) {
      warn('primer', 'audio primer unavailable');
    }
  }

  function kick() {
    try { PPG.audio.start(); } catch (e) { warn('start', 'audio start failed'); }
  }

  function unhook() {
    if (!hooked) { return; }
    hooked = false;
    D.removeEventListener('touchend', onGesture, true);
    D.removeEventListener('click', onGesture, true);
    D.removeEventListener('keydown', onGesture, true);
  }

  function silent() {
    return audioDead || L.tone === 'failed' || files.audio === 'failed';
  }

  /* The next touchend, click or keydown after the gesture window starts audio. */
  function onGesture() {
    if (audioReady) {
      kick();
      unhook();
    } else if (silent()) {
      unhook();
    }
  }

  function hook() {
    if (hooked || silent()) { return; }
    hooked = true;
    D.addEventListener('touchend', onGesture, true);
    D.addEventListener('click', onGesture, true);
    D.addEventListener('keydown', onGesture, true);
  }

  function clearGesture() {
    for (var k = 0; k < gesture.length; k++) { clearTimeout(gesture[k]); }
    gesture.length = 0;
  }

  /* WebKit carries a gesture into timers of 1 s or less, so each one is set
     from the click itself (never chained). */
  function gestureTick(last) {
    return function () {
      if (audioReady) {
        clearGesture();
        kick();
      } else if (last) {
        gesture.length = 0;
        hook();
      }
    };
  }

  function openGesture() {
    clearGesture();
    for (var k = 1; k <= 9; k++) { gesture.push(setTimeout(gestureTick(k === 9), k * 100)); }
  }

  /* Whichever of Tone.js and game-audio.js lands second builds the graph. */
  function audioInit() {
    if (audioReady || audioDead || L.tone !== 'loaded' || files.audio !== 'loaded' || !PPG.audio) { return; }
    try {
      audioReady = PPG.audio.init() === true;
    } catch (e) {
      audioReady = false;
    }
    if (!audioReady) {
      audioDead = true;
      unhook();
      warn('audio', 'audio did not start; the game runs silent');
    } else if (!gesture.length) {
      hook();
    }
  }

  function loadTone() {
    var s;
    var t;
    if (L.tone !== 'idle') { return; }
    if (W.Tone) {
      L.tone = 'loaded';
      return;
    }
    if (!cfg.tone) {
      L.tone = 'failed';
      return;
    }
    L.tone = 'loading';
    t = setTimeout(function () {
      if (L.tone === 'loading') {
        L.tone = 'failed';
        unhook();
        warn('tone', 'Tone.js did not load in 15 s; the game runs silent');
      }
    }, 15000);
    s = D.createElement('script');
    s.src = cfg.tone;
    s.async = true;
    s.onload = function () {
      clearTimeout(t);
      L.tone = W.Tone ? 'loaded' : 'failed';
      audioInit();
    };
    s.onerror = function () {
      clearTimeout(t);
      L.tone = 'failed';
      unhook();
      warn('tone', 'Tone.js did not load; the game runs silent');
    };
    head().appendChild(s);
  }

  /* ---------- the game files ---------- */

  function go() {
    try {
      PPG.core.launch();
    } catch (e) {
      warn('launch', 'launch failed: ' + (e && e.message));
    }
    if (!PPG.state || PPG.state.screen === 'idle') { setBusy(false); }
  }

  function fail(why) {
    clearTimeout(gameTimer);
    gameTimer = 0;
    L.state = 'failed';
    setBusy(false);
    warn('load', 'game files did not load (' + why + '); PLAY retries');
  }

  function check() {
    var all = files.css === 'loaded';
    var k;
    if (L.state !== 'loading') { return; }
    if (files.css === 'failed') {
      fail('game.css');
      return;
    }
    for (k = 0; k < ORDER.length; k++) {
      if (files[ORDER[k]] === 'failed') {
        fail(ORDER[k]);
        return;
      }
      if (files[ORDER[k]] !== 'loaded') { all = false; }
    }
    if (all) {
      clearTimeout(gameTimer);
      gameTimer = 0;
      L.state = 'ready';
      audioInit();
      go();
    }
  }

  function mark(key, state) {
    return function () {
      files[key] = state;
      if (key === 'audio') { audioInit(); }
      check();
    };
  }

  function loadCss() {
    var t;
    function ok() {
      clearTimeout(t);
      if (files.css === 'loading') {
        files.css = 'loaded';
        check();
      }
    }
    if (!urls.css) {
      files.css = 'loaded';
      return;
    }
    if (cssLink && cssLink.parentNode) { cssLink.parentNode.removeChild(cssLink); }
    files.css = 'loading';
    cssLink = D.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = urls.css;
    /* Its onload, or 3 s, whichever comes first. */
    t = setTimeout(ok, 3000);
    cssLink.onload = ok;
    cssLink.onerror = function () {
      clearTimeout(t);
      if (files.css === 'loading') {
        files.css = 'failed';
        check();
      }
    };
    head().appendChild(cssLink);
  }

  /* Dynamic scripts with async = false download in parallel and run in order. */
  function loadGame() {
    var k;
    var key;
    var s;
    L.state = 'loading';
    if (files.css !== 'loaded' && files.css !== 'loading') { loadCss(); }
    for (k = 0; k < ORDER.length; k++) {
      key = ORDER[k];
      if (files[key] === 'loaded' || files[key] === 'loading') { continue; }
      if (!urls[key]) {
        files[key] = 'failed';
        continue;
      }
      files[key] = 'loading';
      s = D.createElement('script');
      s.src = urls[key];
      s.async = false;
      s.onload = mark(key, 'loaded');
      s.onerror = mark(key, 'failed');
      head().appendChild(s);
    }
    clearTimeout(gameTimer);
    gameTimer = setTimeout(function () {
      gameTimer = 0;
      if (L.state === 'loading') { fail('timed out'); }
    }, 12000);
    check();
  }

  /* ---------- PLAY ---------- */

  function launch() {
    var st = PPG.state;
    if (L.state === 'loading' || (st && st.screen !== 'idle')) { return; }
    if (!btn) { init(); }
    /* The position before PLAY; theme.js's capture listener has restored it. */
    L.scrollY = W.pageYOffset || D.documentElement.scrollTop || 0;
    setBusy(true);
    prime();
    if (audioReady) {
      kick();
    } else {
      openGesture();
    }
    loadTone();
    if (L.state === 'ready') {
      go();
    } else {
      loadGame();
    }
  }

  function onClick() {
    launch();
  }

  function init() {
    var b = D.getElementById('game-play-btn');
    if (b === btn) { return; }
    if (btn) { btn.removeEventListener('click', onClick, false); }
    btn = b;
    if (btn) { btn.addEventListener('click', onClick, false); }
  }

  function forward(name, arg) {
    return function () {
      var c = PPG.core;
      if (files.core !== 'loaded' || !c || typeof c[name] !== 'function') { return undefined; }
      try {
        return c[name](arg);
      } catch (e) {
        warn(name, name + ' failed: ' + (e && e.message));
      }
      return undefined;
    };
  }

  api.init = init;
  api.launch = launch;
  api.returnToSite = forward('returnToSite');
  api.pause = forward('pause', 'api');
  api.resume = forward('resume');
  api.destroy = forward('destroy');
  /* A new run with Play Again semantics; from the home page it launches. */
  api.start = function () {
    if (files.core !== 'loaded' || !PPG.core) { return; }
    if (!PPG.state || PPG.state.screen === 'idle') {
      launch();
      return;
    }
    forward('startRun')();
  };
  W.PineParkGame = api;
  init();
})();
